import { OperationalModel } from '@constants/canvas/layers';
import { CiaFilters } from '@context/ProjectFilters/types';
import { BehaviorSubject } from 'rxjs';

type Filters = {
  validationStatus: string[];
  operationalStatuses: string[];
  operatingModelStatuses: OperationalModel[];
  reviewStatus: string[];
  domains: string[];
  partners: string[];
  cia: CiaFilters;
};

export const filtersSubject = new BehaviorSubject<Filters>({
  validationStatus: [],
  operationalStatuses: [],
  operatingModelStatuses: [],
  reviewStatus: [],
  domains: [],
  partners: [],
  cia: {
    assurance_level: {},
    coverage: {},
    applicability: {},
  },
});
